/**
 * useToast — wrapper around Notyf (vendor lib loaded via index.html)
 * Call success() / error() / info() from any component.
 */

declare const Notyf: any;

let _instance: any = null;

function getInstance() {
  if (!_instance) {
    _instance = new Notyf({
      duration: 3500,
      position: { x: 'right', y: 'top' },
      ripple: true,
      dismissible: true,
      types: [
        {
          type: 'success',
          background: 'var(--bs-success)',
          icon: { className: 'ri ri-check-line', tagName: 'i', color: '#fff' },
        },
        {
          type: 'error',
          background: 'var(--bs-danger)',
          icon: { className: 'ri ri-close-circle-line', tagName: 'i', color: '#fff' },
        },
        {
          type: 'info',
          background: 'var(--bs-info)',
          icon: { className: 'ri ri-information-line', tagName: 'i', color: '#fff' },
        },
        {
          type: 'warning',
          background: 'var(--bs-warning)',
          icon: { className: 'ri ri-alert-line', tagName: 'i', color: '#fff' },
        },
      ],
    });
  }
  return _instance;
}

export function useToast() {
  return {
    success: (message: string) => getInstance().success(message),
    error: (message: string) => getInstance().error(message),
    info: (message: string) => getInstance().open({ type: 'info', message }),
    warning: (message: string) => getInstance().open({ type: 'warning', message }),
  };
}
